<template>
  <div class="ds-container">
    <section class="ds-header">
      <div class="ds-title">
        <h2>Lotes enviados</h2>
      </div>
      <div class="btn-title-container">
        <Loading :class="{ icon: true, reload: true, loading }" @click="() => !loading && getBatches()"/>
        <!-- <b-button variant="outline-primary no-print" @click="print">Imprimir</b-button> -->
      </div>
    </section>
    <section>
      <SentLotsFilter 
        :statusOptions="statusOptions"
         @change="onChangeFilter" 
         class="no-print" 
      />
    </section>
    <section v-if="batches.length">
      <SentLotsContainer
        v-for="batch in batches"
        :key="batch.id"
        :type="batch.type"
        :batch="batch"
        :getGuide="getGuide"
        :openHistoric="openHistoric"
        :openDocumentModal="openDocumentModal"
        @onUpdate="getBatches"
        @updateGuideRows="handleGuideRows"
        @openDocumentListModal="openDocumentListModal"
        @openInfo="openInfoSidebar"
        @onManageGuides="openManageGuides"
        @finishBatch="finishBatch"
        @openFileModal="openModalBatchFilesUpload"
      />

      <div class="pagination-position">
        <b-pagination
          size="sm"
          v-model="currentPage"
          :total-rows="totalItems"
          :per-page="perPage"
          first-number
          last-number
        />
      </div>
    </section>
    <NoFiltersResults v-else message="Ainda não há lotes disponíveis." />
    <TissGuideAuditModal :tissGuideAudits="tissGuideAudits" />

    <SusGuidesModalsContainer
      :patient="patient"
      :susGuide="susGuide"
      :clinicHealthPlan="clinicHealthPlan"
      :appointmentId="tissGuide.appointment_id"
      :getLastTissGuide="getLastTissGuide"
      :clearTissGuide="clearTissGuide"
      :required_fields="tissRequiredCustomField"
      readonly
      :setTissGuide="setTissGuide"
      :getGuide="getGuide"
    />

    <SusGuideFilesContainer
      :file="file"
      :batch="batch"
      :susGuide="susGuide"
      :susBatches="guidesRows"
      :openDocumentModal="openDocumentModal"
      :openEditFileModal="openEditFileModal"
      :clearFile="clearFile"
      @hide-file-list-modal="hideFileListModal"
      :files="files"
    />

    <GuidesInfoSidebar
      :batchId="selectedBatchId"
      @updateGuide="getBatches"
    />

    <ImportTissXMLModal :getBatches="getBatches" />
    <TissBatchFilesModal :batchId="selectedBatchId"/>

    <BillsToReceiveSusModal 
      :billToReceive="billToReceive" 
      @reload="getBatches"
      @hide="billToReceive = null"
    />
  </div>
</template>

<script>
import { SusBatch }  from '@/modules/sus/manageGuides/utils/statuses'
import { getCurrentClinic } from '@/utils/localStorageManager'
import { handleGuideUpdate } from '@/utils/invoicingSusHelper'
import { mapState } from 'vuex'
import api from '@/modules/sus/api'

export default {
  props: {
    print: Function,
  },
  components: {
    Loading: () => import('@/assets/icons/loading.svg'),
    // UploadIcon: () => import('@/assets/icons/upload.svg'),
    SentLotsContainer: () => import('@/modules/sus/manageGuides/layouts/SentLotsContainer'),
    SentLotsFilter: () => import('@/components/Sus/Generic/Filters/SentLotsFilter.vue'),
    TissGuideAuditModal: () => import('@/components/Sus/Modal/TissGuideAuditModal.vue'),
    SusGuideFilesContainer: () => import('@/layouts/InvoicingSus/SusGuide/SusGuideFilesContainer.vue'),
    NoFiltersResults: () => import('@/components/General/noFilterResults'),
    ImportTissXMLModal: () => import('@/components/Sus/Modal/ImportTissXMLModal'),
    GuidesInfoSidebar: () => import('@/modules/sus/manageGuides/sidebar/GuidesInfoSidebar.vue'),
    BillsToReceiveSusModal: () => import('@/modules/financial/modals/BillsToReceiveSusModal'),
    TissBatchFilesModal: () => import('@/modules/sus/manageGuides/components/TissBatchFilesModal'),
    SusGuidesModalsContainer: () => import('@/layouts/InvoicingSus/SusGuide/SusGuidesModalsContainer.vue'),
  },
  async mounted() {
    await this.getBatches()
  },
  data() {
    return {
      loading: false,
      clinic: getCurrentClinic(),
      statusOptions: [
        SusBatch.BATCH_STATUS_SENT,
        SusBatch.BATCH_STATUS_RECEIVED,
        SusBatch.BATCH_STATUS_INVOICED_PARTIAL,
        SusBatch.BATCH_STATUS_INVOICED
      ],
      batches: [],

      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      filters: {
        tab: 'sent',
      },

      batchSelected: [],
      modalSelectedBatch: {},
      tissGuideAudits: [],
      file: {},
      files: [],
      patient: {},
      tissGuide: {},
      susGuide: {},
      batch: {},
      clinicHealthPlan: {},
      guidesRows: [],
      tissRequiredCustomField: {},
      selectedBatchId: null,
      isOpenInfoSidebar: false,
      billToReceive: {}
    }
  },
  computed: {
    ...mapState({
      reloadContent: state => state.tiss.reloadContent
    }),
    showImportXml() {
      return process.env !== 'production'
    }
  },
  methods: {
    handleGuideRows(value) {
      this.guidesRows = this.guidesRows.concat(value)
    },
    async onChangeFilter(newFilter) {
      this.filters = newFilter
      await this.getBatches()
    },
    
    async getBatches() {
      const isLoading = this.$loading.show()
      const filters = this.filters
      filters.type = filters.type?.value

      try {
        this.tableRows = []
        const { data } = await api.getSusBatches(this.clinic.id, this.currentPage,{
          filters: this.filters,
          type: 'Enviado'
        })
        this.currentPage = data.current_page
        this.perPage = data.per_page
        this.totalItems = data.total

        this.batches = data.data
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        isLoading.hide()
      }
    },
    
    async finishBatch(batch) {
      try {
        if(batch.status === SusBatch.BATCH_STATUS_GLOSSED){
          this.$swal({
            title: 'Finalizar lote glosado',
            html: `Deseja realmente finalizar este lote com a situação 'Glosado'? Esta ação é irreversível e impedirá futuras alterações.`,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true
            }).then(async res => {
            if (res.isConfirmed) {
              const props = {
                status: SusBatch.BATCH_STATUS_FINISHED,
                clinic_id: this.clinic.id
              }
              await api.updateSusBatch(batch.id, props);
              this.getBatches();
              this.$toast.success('Situação atualizada com sucesso!');
            }
          });
        } else {
          this.setFinishBatch(batch);
        }
      } catch (err) {
        this.$toast.warning(err.message)
      }     
    },
    async setFinishBatch(batch){
      await api.getBatchBillData(batch.id)
      .then(response => {
        this.billToReceive = response.data;
        this.$bvModal.show('bills-to-receive-sus-modal')
      })
      .catch(error => {
        console.error('Erro na requisição:', error)
      });
    },
    async openManageGuides(batchInfo) {
      if (!batchInfo) return
      if (!this.reloadContent) {
        await this.$router.push({
          name: 'tiss-manage-guides',
          params: { batchId: batchInfo.batch.id }
        })
      }
    },
    openInfoSidebar(id) {
      this.selectedBatchId = id
      this.$root.$emit('bv::toggle::collapse', 'guides-info-sidebar')
    },

    parseDate(date) {
      return this.moment(date).format('DD/MM/YYYY')
    },
    async getGuide(susGuide, notOpen) {
      const isLoading = this.$loading.show()
      try {
        const id = susGuide?.id ?? susGuide
        const response = await this.api.getSusGuideById(id)
        this.susGuide = response.data
        if (notOpen) return
        this.patient = this.susGuide.patient
        // await this.getClinicHealthPlan(this.tissGuide.invoicing_tiss_setting_id)
        this.handleGuide(this.susGuide.guide_type)
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        isLoading.hide()
      }
    },
    async getLastTissGuide(data) {
      await this.getGuide(data?.guide_id, true)
    },
    async getClinicHealthPlan(invoicingTissSettingId) {
      if (!this.clinic.id || !invoicingTissSettingId) return
      try {
        const response = await this.api.findByClinicIdAndInvoicingTissSettingId(
          this.clinic.id,
          invoicingTissSettingId
        )
        this.clinicHealthPlan = response.data
        this.tissRequiredCustomField =
          this.clinicHealthPlan.invoicing_tiss_setting.tiss_information.tiss_required_custom_field
      } catch (error) {
        this.$toast.error(error.message)
      }
    },
    openDocumentModal(susGuide) {
      this.susGuide = susGuide
      this.$bvModal.show('sus-batch-file-modal')
    },
    async getSusBatchFiles(batchId) {
      const isLoading = this.$loading.show()
      try {
        const response = await this.api.getSusBatchFiles(this.clinic.id, batchId)
        return response.data
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        isLoading.hide()
      }
    },
    async openHistoric(tissGuideId) {
      await this.getTissGuideAudits(tissGuideId)
      this.$bvModal.show('tiss-guide-audit-modal')
    },
    async getTissGuideAudits(tissGuideId) {
      const isLoading = this.$loading.show()
      try {
        const response = await this.api.getTissGuideAudits(tissGuideId)
        this.tissGuideAudits = response.data
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        isLoading.hide()
      }
    },
    async openDocumentListModal(batch) {
      this.batch = batch
      this.files = await this.getSusBatchFiles(batch.id)
      this.$bvModal.show('sus-batch-file-list-modal')
    },
    openEditFileModal(file) {
      this.file = file
      this.$bvModal.show('sus-batch-file-modal')
    },
    openModalUpdateTiss({ tissGuide, type }) {
      this.tissGuide = tissGuide
      this.guide_type = type
      this.handleGuide()
    },
    clearFile() {
      this.file = {}
    },
    clearTissGuide() {
      this.tissGuide = {}
    },
    hideFileListModal(files) {
      if (files.length) {
        this.$set(this.tissGuide, 'files_count', files.length)
      } else {
        this.$set(this.tissGuide, 'files_count', 0)
      }
    },
    handleGuide(type) {
      const modal = handleGuideUpdate(type)
      this.$bvModal.show(modal)
    },
    setTissGuide(tissGuide) {
      this.tissGuide = null
      this.tissGuide = tissGuide
    },
    openModalBatchFilesUpload(id) {
      this.selectedBatchId = id
      this.$bvModal.show('tiss-batch-files-modal')
    }
  },
  watch: {
    currentPage: {
      handler: async function () {
        await this.getBatches()
      }
    }
  }
}
</script>

<style lang="scss">
.swal2-title {
  font-family: Nunito Sans;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  text-align: left !important;
  border-bottom: 1px solid #D9DFF2;
  padding: 20px 15px;
  text-align: center;
}

.swal2-html-container {
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left !important;
}

.swal2-actions {
  justify-content: end !important;
  margin: 10px 10px;  

  &:hover {
      background-image: none !important;
  }
  &:active {
    background-image: none !important;
  }

  .swal2-cancel {
    font-family: Nunito Sans;
    font-size: 14px;
    height: 40px;
    color: var(--primary-main, #305BF2) !important;
    background-color: #FFF;

    &:focus {
      box-shadow: none !important;
    }
  }

  .swal2-confirm {
    font-family: Nunito Sans;
    font-size: 14px;
    height: 40px;
    background-color: var(--primary-main, #305BF2) !important;
  }
  
}
</style>
<style lang="scss" scoped>
.ds-container {
  padding: 30px 10px;

  .ds-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 0 0;
  }

  .ds-title {
    h2 {
      display: inline-flex;
      align-items: center;
      font-family: 'Red Hat Display';
      font-weight: 500;
      font-size: 18px;
    }

    .icon {
      height: 24px;
      width: 24px;
      margin-left: 5px;
      stroke: var(--neutral-500);
    }
  }

  .btn-title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    button {
      font-weight: bold;
    }

    .btn-primary {
      padding: 4px 15px;
    }

    .upload-icon {
      height: 22px;
      width: 22px;
      margin-right: 7px;
      margin-bottom: 3px;
      overflow: inherit;
      fill: var(--neutral-000);
    }
  }
}

.infoTooltip {
  display: flex;
  flex-direction: column;

  p {
    display: flex !important;
    margin-bottom: 20px;
  }
}
</style>